import React, { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { UserList, FilterAPI, ClaimDownload } from "./ClaimAPI"
import './Filter.css'
import { getFirstDayOfMonth, maxfromat } from "../../utils"
import { errorToast, getSuccessToast, getWarningToast } from "../../toast";
import FormContext from "../../context/FormContext";

function Filter({
    setClaimRecord, setPagination, fetchClaimArray
}) {
    const axiosPrivate = useAxiosPrivate()
    const [userList, setUserList] = useState([])
    let [filterStatus, setFilterStatus] = useState(false)
    const [filter, setFilter] = useState({
        start_date: getFirstDayOfMonth(),
        end_date: maxfromat(),
        search: '',
        username: 'all'
    });
    const { setIsLoading } = useContext(FormContext)
    const fetchUserList = async () => {
        try {
            const array = await UserList(axiosPrivate);
            if (array.status === 200) {
                setUserList(array.data['username']);
            }
        } catch (error) {
            errorToast(`Failed to fetch user list: error:${error.response.status}`, 2000);
        }
    };
    useEffect(() => {
        fetchUserList();
    }, []);

    const handleFilter = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
        // setSearchCondition({ ...searchCondition, [e.target.name]: e.target.value });
    };

    const submitHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)
        try {
            // Assuming Filter is a function that returns a promise
            const response = await FilterAPI(axiosPrivate, filter);

            // Check if the response status is 200
            if (response.status === 200) {
                setClaimRecord(response.data.results);
                setPagination((prev) => ({
                    ...prev,
                    next: response.data?.next,
                    previous: response.data?.previous,
                    count: response.data?.count,
                }));
            } else {
                errorToast(`Unexpected response status: ${response.status}`, 2000);
            }
        } catch (error) {
            // Handle errors and check if error.response is defined
            if (error.response) {
                errorToast(`Failed to load claim: error ${error.response.status}`, 2000);
            } else {
                errorToast('Failed to load claim: unknown error', 2000);
            }
        }
        finally {
            setFilterStatus(true)
            setIsLoading(false)
        }
    };

    const claimDownloadHandler = async () => {
        try {
            setIsLoading(true)
            const form = new FormData()
            form.append('start_date', filter['start_date'])
            form.append('end_date', filter['end_date'])
            const response = await ClaimDownload(axiosPrivate, form)

            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `Aushadhai_Claim_${filter['start_date']}_to_${filter['end_date']}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        catch (error) {
            if (error.status === 204) {
                getWarningToast(`No Claim Created Between ${filter['start_date']} and ${filter['end_date']}`)
            }
            if (error.response) {
                errorToast(`Failed to Download claim: error ${error.response.status}`, 2000);
            }
        }
        finally {
            setIsLoading(false)
        }
    }

    const clearFilter = () => {
        if (!filterStatus) {
            getSuccessToast("No Filter to Clear")
            return
        }
        setFilterStatus(false)
        getSuccessToast('Reset Filter')
        fetchClaimArray()
    }

    const searchBarHandler = (e) => {
        e.preventDefault()
        if(filter['search'] === ''){
            return
        }
        setIsLoading(true);
        axiosPrivate
            .get(`/dashboard/search_claim/?search=${filter['search']}`)
            .then((response) => {
                setClaimRecord(response.data.results);
                setPagination((prev) => ({
                    ...prev,
                    next: response.data?.next,
                    previous: response.data?.previous,
                    count: response.data?.count,
                }));
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => { // Corrected 'finaly' to 'finally'
                setFilterStatus(true)
                setIsLoading(false);
            });
    };


    return (
        <section className="filter__area">
            <form className="filter__form" onSubmit={submitHandler}>
                <div className="filter__form__child">
                    <input
                        type="date"
                        name="start_date"
                        id="start_date"
                        value={filter['start_date']}
                        max={filter["end_date"] === null ? maxfromat() : filter["end_date"]}
                        onChange={handleFilter}
                    />
                    <input
                        type="date"
                        name="end_date"
                        id="end_date"
                        value={filter['end_date']}
                        min={filter["start_date"]}
                        max={maxfromat()}
                        onChange={handleFilter}
                    />
                </div>
                <div className="filter__form__child">
                    <select name="username" id="username" onChange={handleFilter}>
                        <option value="all">All Users</option>
                        {userList && userList.map((username) => (
                            <option key={username} value={username}>{username}</option>
                        ))}
                    </select>
                    <div className="filter__search__area">
                        <input
                            type="search"
                            name="search"
                            id="search"
                            placeholder="Search any Claim"
                            onChange={handleFilter}
                        />
                        <button
                            className="filter__search__button"
                            onClick={searchBarHandler}
                        >&#128269;</button>
                    </div>
                </div>
                <div className="filter__form__child filter__form__child__button">
                    <input type="submit" value="Filter" title="Filter" />
                    <input type="button" value="Clear Filter" onClick={clearFilter} title="Clear Filter" />
                    <input type="button" onClick={claimDownloadHandler} value="Download" title="Download Claim Report" />
                </div>
            </form>
        </section>
    )
}

export default Filter;